import React, { Component } from 'react';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { connect } from 'react-redux';
import { Link } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import { modalActions } from '../../redux/root-action';
import { modals } from '../../utils/constants';
import { keyDown } from '../../utils/helpers';

const StyledOuterContainer = styled.div`
  width: 344px;
  height: 407px;
  box-shadow: 0 8px 8px 0 rgba(45, 57, 64, 0.06), 0 0 4px 0 rgba(45, 57, 64, 0.06);
  background-color: ${tokens.ColorWhite000};
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  border-radius: 0px 0px 4px 4px;
  margin: 0px 16px 0px 16px;
  :hover {
    box-shadow: 0 24px 24px 0 rgba(45, 57, 64, 0.08), 0 0 12px 0 rgba(45, 57, 64, 0.06);
  }
  @media only screen and (min-width: 1024px) and (max-width: 1200px) {
    width: 456px;
  }
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    width: 328px;
    height: 470px;
  }
  @media only screen and (max-width: 767px) {
    width: calc(100% - 32px);
  }
`;

const StyledContainer = styled.div`
  padding: 40px 40px 20px 40px;
  flex-grow: 1;
`;

const StyledHeader = styled.div`
  font-family: Nimbus Sans Bold;
  font-size: 24px;
  line-height: 1.33;
  letter-spacing: -0.5px;
  color: ${tokens.ColorGrey800};
`;

const StyledBody = styled.div`
  font-family: Nimbus Sans Regular;
  color: ${tokens.ColorGrey900};
  line-height: 1.38;
  padding-top: 8px;
`;

const StyledImage = styled.img`
  height: 48px;
  margin-bottom: 40px;
`;

const StyledVideo = styled.div`
  height: 200px;
  background-color: ${tokens.ColorWhite000};
  position: relative;
`;

const StyledVideoImage = styled.img`
  width: 100%;
  height: 200px;
`;

const StyledPlayIcon = styled.a`
  text-decoration: none;
  &:hover,
  &:focus {
    text-decoration: none;
  }
  height: 200px;
  width: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(45, 57, 64, 0.5);
  cursor: pointer;
`;

const StyledLinkContainer = styled.a`
  text-decoration: none;
  &:hover,
  &:focus {
    background-color: rgba(0, 104, 148, 0.08);
    text-decoration: none;
  }
  height: 54px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 1px 0 0 ${tokens.ColorWhite200};
  background-color: rgba(0, 104, 148, 0.04);
  cursor: pointer;
`;

interface Props {
  cardHeader: string;
  cardCopy?: string;
  linkLabel: string;
  link?: string;
  isVideo?: boolean;
  image?: string;
  imageURL?: string;
  showModal: (s: string) => void;
  analyticsId?: string;
}

class Card extends Component<Props> {
  showVideoModal = () => {
    const { showModal } = this.props;
    showModal(modals.VIDEO_MODAL);
  };

  showVideoOnKeyPress = (e: any) => {
    if (e.nativeEvent.code === 'Enter') {
      this.showVideoModal();
    }
  };
  render(): JSX.Element {
    const { cardHeader, cardCopy, linkLabel, isVideo, image, imageURL, link, analyticsId } = this.props;
    return (
      <StyledOuterContainer tabIndex={-1} id={analyticsId}>
        {isVideo && (
          <StyledVideo id={analyticsId + `-` + `vedio`}>
            <StyledVideoImage
              id={analyticsId + `-` + `vedio-image`}
              src={`data:image/png+xml;base64,${image}`}
              alt="video image"
            />
            <StyledPlayIcon
              id={analyticsId + `-` + `play-icon`}
              tabIndex={-1}
              onClick={this.showVideoModal}
              onKeyPress={this.showVideoOnKeyPress}
            >
              <img src={`data:image/svg+xml;base64,${tokens.AssetIconPlay}`} alt="play icon" width={48} height={48} />
            </StyledPlayIcon>
          </StyledVideo>
        )}
        <StyledContainer id={analyticsId + `-` + `container`}>
          {!isVideo && (
            <StyledImage
              id={analyticsId + `-` + `image`}
              src={imageURL ? imageURL : `data:image/svg+xml;base64,${image}`}
              alt="logo"
            />
          )}
          <StyledHeader id={analyticsId + `-` + `header`}>{cardHeader}</StyledHeader>
          {!isVideo && <StyledBody id={analyticsId + `-` + `body`}>{cardCopy}</StyledBody>}
        </StyledContainer>
        <StyledLinkContainer id={analyticsId + `-` + `link-container`} tabIndex={-1}>
          <Link
            id={analyticsId + `-` + `link`}
            linkLabel={linkLabel}
            href={link}
            color={tokens.ColorBrandInteractiveBlue}
            hoverColor={tokens.ColorBrandInteractiveBlueHover}
            onClick={isVideo && this.showVideoModal}
            tabIndex={-1}
            onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.showVideoModal)}
          />
        </StyledLinkContainer>
      </StyledOuterContainer>
    );
  }
}

export default connect(null, { showModal: modalActions.showModal })(Card);
